<div class="p-6">
    <p class="titre2 mb-4">{{ 'PACKAGES_PERSO_MANAGEMENT.DELETE_PACKAGE_CONFIRM_TITLE' | translate }}</p>
    <p class="mb-6">{{ 'PACKAGES_PERSO_MANAGEMENT.DELETE_PACKAGE_CONFIRM_TEXT' | translate }}</p>
    <div class="flex justify-end space-x-4">
        <button (click)="annuler()" class="btn-secondary-novo">
            {{ 'PACKAGES_PERSO_MANAGEMENT.BUTTON_CANCEL' | translate }}
        </button>
        <button (click)="confirmerSuppression()" class="btn-primary-novo">
            {{ 'PACKAGES_PERSO_MANAGEMENT.BUTTON_CONFIRM' | translate }}
        </button>
    </div>
</div>